export default __webpack_public_path__ + "static/media/donatelogo.3c870ab0.webp";